// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_dBP","cls2":"ReferenceEvaluationPage-cls2_jkR ReferenceEvaluationPage-cls1_dBP","dragging":"ReferenceEvaluationPage-dragging_LqX"};